/**
 * Delay before an automatic preview run starts in the margin, ring, boolean
 * and threshold panels, in ms.
 *
 * Long enough that a slider drag, a held key, or typing across several fields
 * coalesces into one compute instead of one per edit: a preview run re-derives
 * the whole volume, so a run per keystroke would stall the panel it is meant
 * to serve.
 */
export const WHOLE_VOLUME_AUTO_PREVIEW_DELAY_MS = 500;

/**
 * Debounce before a preview (re)computes itself.
 *
 * Every post-processing operation previews on its own now, so this paces
 * all of them: a threshold typed digit by digit, a dragged crop box and a
 * smoothing slider would each otherwise queue one GPU compute per value
 * passed through. A UI responsiveness figure only — it does NOT bound how
 * long the preview itself takes, and it is not a clinical value.
 */
export const AUTO_PREVIEW_DELAY_MS = 400;
